"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimer = void 0;
const react_1 = require("react");
const utils_1 = require("../utils");
const useTimer = ({ expiryTimestamp: expire, isPaused = false, }) => {
    const [expiryTimestamp, setExpiryTimestamp] = (0, react_1.useState)(expire);
    const [seconds, setSeconds] = (0, react_1.useState)((0, utils_1.getSecondsFromExpiry)(expiryTimestamp));
    const [isRunning, setIsRunning] = (0, react_1.useState)(true);
    const intervalRef = (0, react_1.useRef)();
    const clearIntervalRef = (0, react_1.useCallback)(() => {
        if (intervalRef.current) {
            setIsRunning(false);
            clearInterval(intervalRef.current);
            intervalRef.current = undefined;
        }
    }, []);
    const start = (0, react_1.useCallback)(() => {
        if (!intervalRef.current) {
            setIsRunning(true);
            intervalRef.current = setInterval(() => {
                const secondsValue = (0, utils_1.getSecondsFromExpiry)(expiryTimestamp);
                if (secondsValue <= 0) {
                    clearIntervalRef();
                }
                setSeconds(secondsValue);
            }, 1000);
        }
    }, [expiryTimestamp, clearIntervalRef]);
    const pause = (0, react_1.useCallback)(() => {
        clearIntervalRef();
    }, [clearIntervalRef]);
    const resume = (0, react_1.useCallback)(() => {
        if (!intervalRef.current) {
            setIsRunning(true);
            intervalRef.current = setInterval(() => setSeconds((prevSeconds) => {
                const secondsValue = prevSeconds - 1;
                if (secondsValue <= 0) {
                    clearIntervalRef();
                }
                return secondsValue;
            }), 1000);
        }
    }, [clearIntervalRef]);
    const restart = (0, react_1.useCallback)((newExpiryTimestamp) => {
        clearIntervalRef();
        setExpiryTimestamp(newExpiryTimestamp);
        setSeconds((0, utils_1.getSecondsFromExpiry)(newExpiryTimestamp));
        start();
    }, [clearIntervalRef, start]);
    (0, react_1.useEffect)(() => {
        setSeconds((0, utils_1.getSecondsFromExpiry)(expiryTimestamp));
        start();
        return clearIntervalRef;
    }, [expiryTimestamp, clearIntervalRef, start]);
    (0, react_1.useEffect)(() => {
        if (isPaused) {
            pause();
        }
    }, [isPaused, pause]);
    return {
        timer: { ...(0, utils_1.getTimeFromSeconds)(seconds) },
        seconds,
        isRunning,
        start,
        pause,
        resume,
        restart,
    };
};
exports.useTimer = useTimer;
